import React, { useContext } from 'react';
import AppContext from 'app/AppContext';
import { usePointedTime } from 'utils/components/TimeSeriesChart/timepoint';
import { ObvTileData } from 'widgets/obvTile/obvTileData';
import { getBucketAtTime } from 'utils/timeseries/bucket';

export interface ObvTileChartValueProps {
    chartKey: string;
    chartData: ObvTileData;
}
export function ObvTileChartValue(props: ObvTileChartValueProps) {
    const { chartData, chartKey } = props;
    const { numberFormat } = useContext(AppContext);
    const time = usePointedTime('ObvTileChartValue' + chartKey);

    const bucket = getBucketAtTime(chartData.timeSeries, time);
    const value = numberFormat.n0(bucket?.obv);

    return <div className="value">{value}</div>;
}
